<template>
  <div>
    <page-main
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @goBack="goBack"
      @reload="reload"
      @selData="selData"
      ref="main"
    >
      <page-header ref="header" slot="header" @submit="handleSubmit" />
    </page-main>

    <pagination
      size="small"
      align="left"
      slot="pager"
      :current-page="page.curPage"
      :page-size="page.pageSize"
      :page-total="page.pageTotal"
      @change="handlePaginationChange"
    />
    <div style="display: flex;justify-content: flex-end;" class="mr-2">
      <el-button @click="() => this.$refs.main.goBack()" size="small">{{
        $l('INDEX.btn_go_back') || '返回'
      }}</el-button>
      <el-button @click="() => this.$refs.main.save()" size="small" type="primary">{{
        $l('INDEX.btn_save') || '保存'
      }}</el-button>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    PageHeader: () => import('./header'),
    PageMain: () => import('./main'),
  },
  data() {
    return {
      tableData: [],
      loading: false,
      page: {
        curPage: 1,
        pageSize: 10,
        pageTotal: 0,
      },
      queryParams: {
        attributeType: 'Content',
        attributeStatusArray: ['Y'],
      },
    }
  },
  created() {
    this.handleSubmit()
  },
  methods: {
    loadData(queryParams) {
      this.queryParams = queryParams
      this.handleSubmit()
      // setTimeout(() => {
      //   this.$refs.header.focusInput();
      // }, 0);
    },
    // 分页查询
    handlePaginationChange(val) {
      this.page = {
        curPage: val.current,
        pageSize: val.size,
        pageTotal: val.total,
      }
      this.$nextTick(() => {
        this.$refs.header.query()
      })
    },
    // 重载表格数据
    reload() {
      this.$refs.header.query()
    },
    // 加载表格数据
    handleSubmit(form) {
      this.loading = true
      this.$api
        .masterAttributeDictionary_list({
          ...this.queryParams,
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.page.pageTotal = res.body.count
          this.tableData = res.body.data
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    selData(masterAttributeDictionaryData) {
      this.$emit('masterAttributeDictionaryData', masterAttributeDictionaryData)
    },
    goBack() {
      this.$emit('chooseMasterAttributeDictionaryClose')
    },
  },
}
</script>
